export default __webpack_public_path__ + "static/media/Wallet-icon.e12e8a80.png";